import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useParams } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import { useRedirectOnRemovedEntity } from '@/hooks/useRedirectOnRemovedEntity';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';

import ConfirmPopup from '../../common/ConfirmPopup';
import FollowUpList from '../FollowUpList';

import s from './FollowUpTabContent.module.scss';

const FollowUpTabContent: React.FC = () => {
  const { id, followUpId } = useParams();
  const { followUp } = useSidebarNoteStore();

  useRedirectOnRemovedEntity(followUp, followUpId, id ? ROUTES.organization.notebook.followUps.create(id) : null);

  React.useEffect(() => {
    followUp.fetchFollowUp();
  }, [followUp]);

  return (
    <div className={s.root}>
      <FollowUpList />
      <ConfirmPopup
        meta={followUp.popupMeta}
        store={followUp.removePopup}
        title="Удалить follow-up?"
        description="Вы действительно хотите удалить этот follow-up? Восстановить его будет невозможно."
      />
    </div>
  );
};

export default observer(FollowUpTabContent);
